import { Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageStore } from '../services/language.store';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  public languageStore = inject(LanguageStore);

  public transform(value: string, ...args: string[]): string {
    if (args.length > 0 && this.languageStore.currentLanguage()?.[value]) {
      let returnValue = this.languageStore.currentLanguage()?.[value];
      args.forEach((arg) => {
        returnValue = returnValue!.replace('{{}}', arg);
      });
      return returnValue!;
    }
    return this.languageStore.currentLanguage()?.[value] ?? value;
  }
}
